// Generate tab and tabpanel ids for accessibility purposes.

const generateTabIds = (tabsId, tabKey) => [
  `${tabsId}-tab-${tabKey}`,
  `${tabsId}-tabpanel-${tabKey}`
];

export default generateTabIds;
